import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@upassignations/feature';
import { ParentService } from './services/parent.service';
import { CustomAppConfig } from '@upassignations/custom-app-config';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'up-assignation-ui-app';
  release_version: string;

  constructor(
    // eslint-disable-next-line no-unused-vars
    private parentService: ParentService,
    // eslint-disable-next-line no-unused-vars
    private config: CustomAppConfig
  ) {
    this.release_version = this.config.getVersion();
  }
}
